import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { map, take } from 'rxjs/operators';

import { UserAccessLevel } from '../core/services/user.service';
import { UserState } from '../core/state/auth.reducer';
import { AuthReturnUrlService } from '../core/services/auth-return-url.service';

export const sysadminGuard: CanMatchFn = () => {
  const router = inject(Router);
  const authReturnUrl = inject(AuthReturnUrlService);
  return inject<Store<{ user: UserState }>>(Store).pipe(
    select((state) => state.user),
    take(1),
    map((userState) => {
      if (!userState.isAuthChecked || !userState.isAuthenticated) {
        authReturnUrl.rememberCurrent();
        return router.createUrlTree(['/auth']);
      }

      const accessLevel =
        userState.user?.access_level_id ?? UserAccessLevel.GUEST;

      // Module-load floor lowered to GLOBAL_ADMIN (proposal §12 Option A);
      // each child re-asserts its own minimum via MinAccessLevelGuard.
      return accessLevel >= UserAccessLevel.GLOBAL_ADMIN
        ? true
        : router.createUrlTree(['/']);
    }),
  );
};
